<div class="flex gap-1 align-items-center"
[ngClass]="{'text-red-600': !isPass, 'text-green-600': isPass}"
>
  <div>
    {{this.rule}}
  </div>
  <i *ngIf="isPass" 
     class="pi pi-check text-xs" ></i>
  <i *ngIf="!isPass" 
     class="pi pi-times text-xs" ></i>
</div>
